import { Component } from 'react'

export class Program extends Component {

	constructor( props ) {
		super( props )

		this.getProgramImage.bind( this )
	}

	AgeTaxonomy( program ) {
		if ( program.ages_label.length ) {
			return (
				<div className="pf-program__age">
					<strong>Ages</strong>
					<span dangerouslySetInnerHTML={{ __html: program.ages_label }} />
				</div>
			)
		}

		return '';
	}

	OptionalButton( program ) {
		if ( program.button ) {
			if ( '_blank' === program.button.target ) {	
				return (
					<a 
						className="pf-button"
						href={ program.button.url }
						target="_blank"
					>
						{ program.button.title }
						<span className="icon-launch-external"></span>
					</a>
				)
			} else {
				return (
					<a 
						className="pf-button"
						href={ program.button.url }
					>
						{ program.button.title }
					</a>
				)
			}
		}

		return ''
	}

	getExcerpt( string ) {
		if ( string.length > 227 ) {
			return string.substring(0, 225) + '...'
		}
		
		return string
	}

	getProgramImage() {
		//let image = this.props.program.image.length ? this.props.program.image : this.props.placeholderImage
		let image = this.props.program?.image?.length ? this.props.program.image : ''
		return image
	}

	Grades( grades ) {
		if ( grades?.length ) {
			return (
				<div className="pf-program__tag">
					<span className="icon-person"></span>Grades {grades}
				</div>
			)
		} else {
			return
		}
	}

	Days( days ) {
		if ( days?.length ) {
			return (
				<div className="pf-program__tag">
					<span className="icon-clock"></span>Days {days}
				</div>
			)
		} else {
			return
		}
	}

	Activities( activities ) {
		if ( activities?.length ) {
			return (
				<p className="pf-program__activities">{activities}</p>
			)
		} else {
			return
		}
	}

	Dates( dates ) {
		if ( dates?.length ) {
			return (
				<div className="pf-program__dates">
					{dates.map((date, i) => {
						return (
							<div className="pf-program__date" key={ i }>
								{ date.date }
							</div>
						)
					})}
				</div>
			)
		} else {
			return
		}
	}

	render() {
		return (
			<a className="pf-program" href={ this.props.program.url }>
				<div className="pf-program__image" dangerouslySetInnerHTML={{ __html: this.getProgramImage() }}></div>

				<div className="pf-program__text">
					<p className="pf-program__subtitle">{ this.props.program.subtitle }</p>

					<h3 className="pf-program__title">
						{ this.props.program.title }
					</h3>

					<div className="pf-program__tags">
						{ this.Grades( this.props.program.grades ) }
						{ this.Days( this.props.program.days ) }
					</div>

					{ this.Dates( this.props.program.dates ) }

					{ this.Activities( this.props.program.activities ) }
				</div>

				<div className="traction-category__border">
					<img src={ this.props.program.border_img } />
				</div>
			</a>
		)
	}
}